import type { ReactNode } from 'react'

export interface InboxRowContentProps {
  children: ReactNode
}

export function InboxRowContent({ children }: InboxRowContentProps): ReactNode {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-0.5 py-2.5">
      {children}
    </div>
  )
}
